// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3P-hz","content":"RecentSearches_content__k6WvV"};